import React from 'react';
import { MenuItemBadge } from './menu.styles';
import { MenuItem } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import { useCleanReloadParam } from './useCleanReloadParam';

const HardRefresh = () => {
    useCleanReloadParam(); // cleans the URL if it contains ?cleared=

    const handleReset = () => {
        // Clear caches, localStorage, etc.
        localStorage.clear();
        sessionStorage.clear();

        if ('caches' in window) {
            caches.keys().then(names => names.forEach(n => caches.delete(n)));
        }

        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations().then(regs => {
                regs.forEach(reg => reg.unregister());
            });
        }

        // Force reload with cache-busting param
        const url = new URL(window.location.href);
        url.searchParams.set('cleared', Date.now()?.toString());
        window.location.href = url.toString();
    };

    return <MenuItem onClick={handleReset}>
        <MenuItemBadge>
            <RefreshIcon />
        </MenuItemBadge>
        <span>Hard Refresh</span>
    </MenuItem>;
};

export default HardRefresh;